import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81690190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-lg" }

import { computed } from 'vue';
import { required } from '@vuelidate/validators';
import {
	UiForm,
	UiCard,
	UiCardDivider,
	UiInput,
	UiRadioTabs,
	UiButton,
	useForm
} from '@/ui-kit';
import { BoolNum } from '@/utils';
import { usePhoneNumberDetails } from '../composition/use-phone-number-details';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberGeneral',
  setup(__props) {

const { phoneNumberDetails, updatePhoneNumberGeneral } =
	usePhoneNumberDetails();
const {
	fillFormData,
	onSubmit,
	isFormChanged,
	formData,
	loading
} = useForm(
	{
		friendlyName: '',
		isSystemPhone: false,
		internationalCalling: BoolNum.false
	},
	{ friendlyName: { required } }
);

const fillForm = () => {
	fillFormData(phoneNumberDetails.value);
};

const isDisabled = computed(
	() => !isFormChanged(phoneNumberDetails.value)
);

fillForm();

const submit = onSubmit(async (data) => {
	await updatePhoneNumberGeneral(data);
	fillForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiCard), { theme: "white" }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), { onSubmit: _unref(submit) }, {
        default: _withCtx(() => [
          _createVNode(_unref(UiCardDivider), {
            title: "General",
            subtitle: "General settings for this phone number."
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(UiInput), {
              label: "Friendly Name",
              subLabel: "Giving a friendly name to this number will help you and your team distinguish between all the numbers in your workspace.",
              name: "friendlyName",
              modelValue: _unref(formData).friendlyName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).friendlyName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(UiRadioTabs), {
              class: "tabs",
              label: "International Calling",
              subLabel: "Allow international calling and messaging on this phone number. Extra charges will apply per message segment and call minute.",
              name: "internationalCalling",
              modelValue: _unref(formData).internationalCalling,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).internationalCalling) = $event)),
              noValidate: true,
              options: [
						{ title: 'No', value: 0 },
						{ title: 'Yes', value: 1 }
					]
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(UiButton), {
              tabindex: "0",
              disabled: _unref(isDisabled),
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}
}

})